

AFRAME.registerComponent('fence', {
    schema: {
        xyCoordinates: {
            type: 'array'
        },
    },
    init: function() {
        this.worldPosition = new THREE.Vector3();
        this.lastValidPosition = {x: 0, y: 0};
    },
    tick: function () {
        this.el.object3D.getWorldPosition(this.worldPosition);
        if (this.isPointInsidePolygon(this.worldPosition.x, this.worldPosition.z, this.data.xyCoordinates)) {
            this.lastValidPosition = {x: this.el.object3D.position.x, y: this.el.object3D.position.z};
        } else {
            this.el.object3D.position.x = this.lastValidPosition.x;
            this.el.object3D.position.z = this.lastValidPosition.y;
        }
    },
    isPointInsidePolygon(x, y, vs) {
        // ray-casting algorithm based on
        // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
        
        var inside = false;
        for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
            var xi = vs[i][0], yi = vs[i][1];
            var xj = vs[j][0], yj = vs[j][1];
            
            var intersect = ((yi > y) != (yj > y))
                && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }
        
        return inside;
    }
});